export const SET_SELECTED_MASS_ID = 'masses/setSelectedMassId';

export default {
  setSelectedMassId: massId => ({
    type: SET_SELECTED_MASS_ID,
    payload: massId,
  }),
};
